/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GenerateGatewayPaymentQRResponse } from '../models/GenerateGatewayPaymentQRResponse';
import type { InstallmentPlanDto } from '../models/InstallmentPlanDto';
import type { LiffContactInfo } from '../models/LiffContactInfo';
import type { LiffUserLinkCheckResult } from '../models/LiffUserLinkCheckResult';
import type { LiffUserLinkRequest } from '../models/LiffUserLinkRequest';
import type { LineOaShopLiffUser } from '../models/LineOaShopLiffUser';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class LiffShopService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Check LIFF account connection
     * @returns LiffUserLinkCheckResult OK
     * @throws ApiError
     */
    public checkLineOaShopLiffUserLinked({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<LiffUserLinkCheckResult> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/public/liff/shops/{shopId}/link',
            path: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Link LIFF account
     * @returns LineOaShopLiffUser OK
     * @throws ApiError
     */
    public linkLineOaShopLiffUser({
        shopId,
        requestBody,
    }: {
        shopId: string,
        requestBody: LiffUserLinkRequest,
    }): CancelablePromise<LineOaShopLiffUser> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/public/liff/shops/{shopId}/link',
            path: {
                'shopId': shopId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Unlink LIFF account
     * @returns any OK
     * @throws ApiError
     */
    public unlinkLineOaShopLiffUser({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/public/liff/shops/{shopId}/link',
            path: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Get LIFF shop user profile
     * @returns LineOaShopLiffUser OK
     * @throws ApiError
     */
    public getLineOaShopLiffUser({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<LineOaShopLiffUser> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/public/liff/shops/{shopId}/user',
            path: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Get LIFF shop user installment plans
     * @returns InstallmentPlanDto OK
     * @throws ApiError
     */
    public getLineOaShopLiffUserInstallmentPlans({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<Array<InstallmentPlanDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/public/liff/shops/{shopId}/installment-plan',
            path: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Generate QR for LIFF shop user installment plan
     * @returns GenerateGatewayPaymentQRResponse OK
     * @throws ApiError
     */
    public generateLineOaShopLiffUserInstallmentPlanPaymentQr({
        shopId,
        installmentPlanId,
    }: {
        shopId: string,
        installmentPlanId: string,
    }): CancelablePromise<GenerateGatewayPaymentQRResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/public/liff/shops/{shopId}/installment-plan/{installmentPlanId}/pay/generate-qr',
            path: {
                'shopId': shopId,
                'installmentPlanId': installmentPlanId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Get LIFF shop contact info
     * @returns LiffContactInfo OK
     * @throws ApiError
     */
    public getLineOaShopContactInfo({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<LiffContactInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/public/liff/shops/{shopId}/contact-info',
            path: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
